'use client'

import { Params } from '@/lib/types/shared/page.types';
import { useTranslations } from 'next-intl';
import { Link } from '@/lib/navigation';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useState, useRef } from 'react';
import { Container } from '@mui/material';
import { ButtonOne } from '@/components/shared';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';

export interface NavDropdown {
    label: string;
    items: {
        label: string;
        link: string;
    }[];
};

type Props = {
    items: NavDropdown[];
    params: Params;
};

export default function MobileNavDropdown({ items, params }: Props) {
    const t = useTranslations();

    const [isOpen, setIsOpen] = useState(false);

    const [activeItem, setActiveItem] = useState<NavDropdown | null>(null);

    const wrapperRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLDivElement>(null);
    const dropdownRef = useRef<HTMLDivElement>(null);

    function handleClick() {
        setIsOpen(!isOpen);
    }

    return (
      <>
        <div className='flex items-center gap-2'>
            <div className='flex items-center gap-2'>
                <div
                    ref={wrapperRef}
                    className="c-secondary c-h-secondary cursor-pointer"
                >
                    <div ref={buttonRef} className='w-fit h-fit'>
                        <ButtonOne 
                            text={''} 
                            type='button'
                            onclick={handleClick}
                            variant='border-transparent' 
                            paddingX='small' 
                            hoverEffect={true}>

                            {isOpen ? (
                                <CloseIcon className='font-bold' />
                            ) : (
                                <MenuIcon className='font-bold' />
                            )}
                        </ButtonOne>
                    </div>
                        
                    {isOpen && (
                        <>
                            <div 
                                ref={dropdownRef}
                                className={`${isOpen ? 'block' : 'hidden'} absolute origin-top-right w-full -z-1 h-screen-mobile-min-26 rounded-b-lg top-14 left-0 right-0 py-5 bg-primary-gray-950 overflow-y-auto`}
                            >
                                <Container className='flex flex-col gap-y-4 pt-4 mobile-nav-container'>
                                    <Link className='text-2xl font-semibold border-b border-white' onClick={handleClick} href={"/"}>{t('home')}</Link>

                                    {items.map((item, index) => (
                                        <div key={index} className='flex flex-col gap-y-3'>
                                            <div className="flex justify-between items-center gap-x-3" onClick={activeItem === item ? () => setActiveItem(null) : () => setActiveItem(item)}>
                                                <p className="text-2xl">
                                                    {item.label}
                                                </p>

                                                {activeItem === item ? (
                                                    <ChevronDownIcon className='text-2xl' />
                                                ) : (
                                                    <ChevronRightIcon className='text-2xl' />
                                                )}
                                            </div>

                                            <div className={`${activeItem === item ? 'flex' : 'hidden'} flex-col gap-y-3`}>
                                                {item.items.map((item, index) => (
                                                    <Link key={index} className='text-xl font-medium border-b border-white ml-6' onClick={handleClick} href={item.link}>{item.label}</Link>
                                                ))}
                                            </div>
                                        </div>
                                    ))}

                                    <Link className='text-2xl font-semibold border-b border-white' onClick={handleClick} href={"/about"}>{t('about_us')}</Link>
                                    <Link className='text-2xl font-semibold border-b border-white' onClick={handleClick} href={"/contact"}>{t('contact')}</Link>
                                </Container>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
      </>
    )
}
